import React from 'react'
import PageForm from '../form'

const CancellationPolicy = () => {
  return <PageForm title="Cancellation Policy" Key="cancellation-policy" />
}

export default CancellationPolicy
